"use client";

import { useGetSettingRealTimeTermsOwf } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingRealTimeTermsOwf";
import { useSettingSkipOwFUpsell } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingSkipOwFUpsell";
import { SignupFormContainer } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/CommonStyles";
import { UpsellContainer } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/upsell-template/UpsellContainer";
import { UpsellLayout } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/upsell-template/UpsellLayout";
import { useSignUpUPLT } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_hooks/useSignUpUPLT";
import { OpenWithFaireApplicationForm } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/open-with-faire/application/__internal__/OpenWithFaireApplicationForm";
import { useSaveRequestAndGoToNextStep } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/signupStepper";
import { Step } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/Step";
import { useHandleOwFSkip } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/useHandleOwFSkip";
import { Core } from "@faire/design-tokens";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import React from "react";

export const OwFApplicationStep: React.FC = () => {
  const hasSkippedOwFUpsell = useSettingSkipOwFUpsell();
  const isRealTimeTermsOwf = useGetSettingRealTimeTermsOwf();

  const { saveAndGoToNextStep } = useSaveRequestAndGoToNextStep(
    Step.OWF_APPLICATION
  );
  useSignUpUPLT({ step: Step.OWF_APPLICATION });

  const handleSkip = useHandleOwFSkip();

  // @roychon-faire: currently mocking the auto approval of the OWF application, will need to update this once we have approval flow logic in backend https://fairewholesale.atlassian.net/browse/FD-272855
  // isOwFAutoApproved should be true if REAL_TIME_TERMS_OWF_250618 is enabled and user is auto-approved
  const handleContinue = () => {
    saveAndGoToNextStep(undefined, {
      realTimeOwF: isRealTimeTermsOwf,
    });
  };

  if (hasSkippedOwFUpsell) {
    return (
      <SignupFormContainer>
        <Column align="center">
          <OpenWithFaireApplicationForm
            onSkip={handleSkip}
            onSubmit={handleContinue}
          />
        </Column>
      </SignupFormContainer>
    );
  }

  return (
    <UpsellLayout
      backgroundColor={Core.surface.info}
      onClose={hasSkippedOwFUpsell ? handleSkip : undefined}
    >
      <UpsellContainer>
        <Column align="center">
          <OpenWithFaireApplicationForm
            onSkip={handleSkip}
            onSubmit={handleContinue}
          />
        </Column>
      </UpsellContainer>
      <Spacer height={{ mobileAndAbove: "4x", tabletAndAbove: "5x" }} />
    </UpsellLayout>
  );
};
